export default __webpack_public_path__ + "static/media/mom.blur.2121dfef.jpg";